/* tslint:disable */
/* eslint-disable */
/**
 * ELZA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 * Area in which to search: preferred names only / all names / all parts / by entity code
 */
export const ApSearchArea = {
    PreferNames: 'PREFER_NAMES',
    AllNames: 'ALL_NAMES',
    AllParts: 'ALL_PARTS',
    EntityCode: 'ENTITY_CODE'
};
/**
 * Search strategy for criteria-based access-point queries (name / username fields)
 */
export const ApSearchType = {
    Disabled: 'DISABLED',
    Join: 'JOIN',
    Fulltext: 'FULLTEXT',
    RightSideLike: 'RIGHT_SIDE_LIKE'
};
/**
 * States of ApState
 */
export const ApStateApproval = {
    New: 'NEW',
    ToApprove: 'TO_APPROVE',
    Approved: 'APPROVED',
    ToAmend: 'TO_AMEND'
};
/**
 * Data types for ItemData classes
 */
export const DataType = {
    Int: 'INT',
    String: 'STRING',
    Text: 'TEXT',
    Unitdate: 'UNITDATE',
    Unitid: 'UNITID',
    FormattedText: 'FORMATTED_TEXT',
    Coordinates: 'COORDINATES',
    RecordRef: 'RECORD_REF',
    Decimal: 'DECIMAL',
    Structured: 'STRUCTURED',
    Enum: 'ENUM',
    FileRef: 'FILE_REF',
    JsonTable: 'JSON_TABLE',
    Date: 'DATE',
    UriRef: 'URI_REF',
    Bit: 'BIT'
};
/**
 * Type of field for FieldValueFilter
 */
export const FieldType = {
    FondsField: 'FONDS_FIELD',
    NodeField: 'NODE_FIELD',
    DescItem: 'DESC_ITEM'
};
/**
 * Types of filters
 */
export const FilterType = {
    FieldValue: 'fieldValue',
    Contains: 'contains',
    Logical: 'logical'
};
/**
 * Funds specific field names  Fields are used for FundsFilterField.
 */
export const FondsFieldName = {
    FondsId: 'fondsId',
    Name: 'name',
    CreateDate: 'createDate',
    InternalCode: 'internalCode',
    FondsNumber: 'fondsNumber',
    Unitdate: 'unitdate',
    Mark: 'mark',
    InstitutionId: 'institutionId',
    InstitutionCode: 'institutionCode'
};
/**
 * File system item type
 */
export const FsItemType = {
    Folder: 'FOLDER',
    File: 'FILE'
};
/**
 * Item mandatory type
 */
export const MandatoryType = {
    Required: 'REQUIRED',
    Recommended: 'RECOMMENDED',
    Possible: 'POSSIBLE',
    Impossible: 'IMPOSSIBLE'
};
/**
 * Stav JP
 */
export const NodeConformityState = {
    Ok: 'OK',
    Err: 'ERR'
};
/**
 * Node specific field names  Node fields are used for FieldValueFilter.
 */
export const NodeFieldName = {
    ConformityError: 'conformityError',
    ConformityMissing: 'conformityMissing',
    Uuid: 'uuid'
};
/**
 * Operation type for FieldValueFilter
 */
export const OperationCompareType = {
    Eq: 'EQ',
    Neq: 'NEQ',
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Startwith: 'STARTWITH',
    Endwith: 'ENDWITH',
    Contains: 'CONTAINS',
    Intersect: 'INTERSECT',
    IsIn: 'IS_IN',
    IsNull: 'IS_NULL',
    NotNull: 'NOT_NULL'
};
/**
 * Operation type for LogicalFilter
 */
export const OperationLogicalType = {
    And: 'AND',
    Or: 'OR'
};
/**
 * Method of replacing ApAccessPoint
 */
export const ReplaceType = {
    Simple: 'SIMPLE',
    CopyAll: 'COPY_ALL'
};
/**
 * Types of report output formats
 */
export const ReportReportFormat = {
    Json: 'JSON',
    Csv: 'CSV'
};
/**
 * Types of statistics values
 */
export const ReportValueType = {
    Int: 'INT',
    String: 'STRING',
    Boolean: 'BOOLEAN',
    Date: 'DATE',
    UserId: 'USER_ID',
    GroupId: 'GROUP_ID',
    FundId: 'FUND_ID',
    ApId: 'AP_ID',
    ItemTypeId: 'ITEM_TYPE_ID',
    ItemSpecId: 'ITEM_SPEC_ID',
    ScopeId: 'SCOPE_ID',
    ApTypeId: 'AP_TYPE_ID'
};
/**
 * Status of async request
 */
export const RequestProcessState = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Finished: 'FINISHED',
    Error: 'ERROR'
};
/**
 * Request state
 */
export const RequestState = {
    Open: 'OPEN',
    Queued: 'QUEUED',
    Sent: 'SENT',
    Processed: 'PROCESSED',
    Rejected: 'REJECTED'
};
/**
 * States of ApRevState
 */
export const RevisionState = {
    Active: 'ACTIVE',
    ToApprove: 'TO_APPROVE',
    ToAmend: 'TO_AMEND'
};
/**
 * Order of sorting
 */
export const SortingOrder = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 * Binding synchronisation state
 */
export const SyncState = {
    SyncOk: 'SYNC_OK',
    NotSynced: 'NOT_SYNCED',
    LocalChange: 'LOCAL_CHANGE'
};
/**
 * Entity type for task
 */
export const TasksEntityType = {
    Ap: 'AP',
    ApRev: 'AP_REV'
};
/**
 * Task status
 */
export const TasksStatus = {
    New: 'NEW',
    Cancelled: 'CANCELLED',
    Finished: 'FINISHED'
};
/**
 * Type of update Item
 */
export const UpdateOp = {
    Create: 'CREATE',
    Update: 'UPDATE',
    Delete: 'DELETE'
};
/**
 * AccesspointsApi - axios parameter creator
 */
export const AccesspointsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Asynchronously export access points matching the given search query to CSV. Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. The filter shape mirrors the scalar parameters of /registry/search, so the same registry-list filter values can be passed through. Empty body / null fields means \"all access points visible to the user\".
         * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBatchExport: (accessPointBatchExportParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessPointBatchExportParams' is not null or undefined
            assertParamExists('accessPointBatchExport', 'accessPointBatchExportParams', accessPointBatchExportParams);
            const localVarPath = `/accesspoint/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessPointBatchExportParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Change state of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeState: (id, apStateUpdate, apVersion, assignTo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointChangeState', 'id', id);
            // verify required parameter 'apStateUpdate' is not null or undefined
            assertParamExists('accessPointChangeState', 'apStateUpdate', apStateUpdate);
            const localVarPath = `/accesspoint/{id}/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            if (assignTo !== undefined) {
                localVarQueryParameter['assignTo'] = assignTo;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apStateUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Change state of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeStateRevision: (id, revStateChange, apVersion, assignTo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointChangeStateRevision', 'id', id);
            // verify required parameter 'revStateChange' is not null or undefined
            assertParamExists('accessPointChangeStateRevision', 'revStateChange', revStateChange);
            const localVarPath = `/accesspoint/{id}/revision/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            if (assignTo !== undefined) {
                localVarQueryParameter['assignTo'] = assignTo;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(revStateChange, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copying an archive entity
         * @param {string} id id of accesspoint
         * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCopyAccessPoint: (id, copyAccessPointDetail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointCopyAccessPoint', 'id', id);
            // verify required parameter 'copyAccessPointDetail' is not null or undefined
            assertParamExists('accessPointCopyAccessPoint', 'copyAccessPointDetail', copyAccessPointDetail);
            const localVarPath = `/accesspoint/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(copyAccessPointDetail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {object} body data for creating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreatePart: (id, body, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointCreatePart', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accessPointCreatePart', 'body', body);
            const localVarPath = `/accesspoint/{id}/part`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating a new revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreateRevision: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointCreateRevision', 'id', id);
            const localVarPath = `/accesspoint/{id}/revision`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidation of access point (delete/replace)
         * @param {string} id id of accesspoint
         * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoint: (id, deleteAccessPointDetail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeleteAccessPoint', 'id', id);
            const localVarPath = `/accesspoint/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccessPointDetail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidation of access points
         * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoints: (deleteAccessPointsDetail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'deleteAccessPointsDetail' is not null or undefined
            assertParamExists('accessPointDeleteAccessPoints', 'deleteAccessPointsDetail', deleteAccessPointsDetail);
            const localVarPath = `/accesspoint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccessPointsDetail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeletePart: (id, partId, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeletePart', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointDeletePart', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/part/{partId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deleting a revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevision: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeleteRevision', 'id', id);
            const localVarPath = `/accesspoint/{id}/revision`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete part of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevisionPart: (id, partId, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeleteRevisionPart', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointDeleteRevisionPart', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/revision/part/{partId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Decision on forced export ELZA -> CAM
         * @param {number} queueItemId id of queue
         * @param {boolean} force force export: yes or no
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointExportForceOrNo: (queueItemId, force, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'queueItemId' is not null or undefined
            assertParamExists('accessPointExportForceOrNo', 'queueItemId', queueItemId);
            // verify required parameter 'force' is not null or undefined
            assertParamExists('accessPointExportForceOrNo', 'force', force);
            const localVarPath = `/accesspoint/export/{queueItemId}`
                .replace(`{${"queueItemId"}}`, encodeURIComponent(String(queueItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List of automatically generated elements of the description
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetAutoitems: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointGetAutoitems', 'id', id);
            const localVarPath = `/accesspoint/{id}/autoitems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get invalidated (deleted) entities
         * @param {number} [page] number of the page
         * @param {number} [pageSize] page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetInvalidatedEntities: (page, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/accesspoint/invalidated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a list of entity processors
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetLastParticipants: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointGetLastParticipants', 'id', id);
            const localVarPath = `/accesspoint/{id}/lastParticipants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List of automatically generated description elements for revision
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetRevAutoitems: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointGetRevAutoitems', 'id', id);
            const localVarPath = `/accesspoint/{id}/revision/autoitems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Merge ApRevision & ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointMergeRevision: (id, apStateUpdate, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointMergeRevision', 'id', id);
            // verify required parameter 'apStateUpdate' is not null or undefined
            assertParamExists('accessPointMergeRevision', 'apStateUpdate', apStateUpdate);
            const localVarPath = `/accesspoint/{id}/revision/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apStateUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Restore deleted entity and return to original state
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointRestoreAccessPoint: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointRestoreAccessPoint', 'id', id);
            const localVarPath = `/accesspoint/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
         * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSearch: (accessPointSearchParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accessPointSearchParams' is not null or undefined
            assertParamExists('accessPointSearch', 'accessPointSearchParams', accessPointSearchParams);
            const localVarPath = `/accesspoint/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessPointSearchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set the preferred name of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferName: (id, partId, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointSetPreferName', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointSetPreferName', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/part/{partId}/prefer-name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set the preferred name of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferNameRevision: (id, partId, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointSetPreferNameRevision', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointSetPreferNameRevision', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/revision/part/{partId}/prefer-name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId id of part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdatePart: (id, partId, body, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointUpdatePart', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointUpdatePart', 'partId', partId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accessPointUpdatePart', 'body', body);
            const localVarPath = `/accesspoint/{id}/part/{partId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a revision part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} revPartId id of revision part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdateRevisionPart: (id, revPartId, body, apVersion, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointUpdateRevisionPart', 'id', id);
            // verify required parameter 'revPartId' is not null or undefined
            assertParamExists('accessPointUpdateRevisionPart', 'revPartId', revPartId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accessPointUpdateRevisionPart', 'body', body);
            const localVarPath = `/accesspoint/{id}/revision/part/{revPartId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"revPartId"}}`, encodeURIComponent(String(revPartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Validation of an archive entity
         * @param {number} id id of accesspoint
         * @param {boolean} [includeRevision] include revision
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointValidateAccessPoint: (id, includeRevision, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointValidateAccessPoint', 'id', id);
            const localVarPath = `/accesspoint/{id}/validate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeRevision !== undefined) {
                localVarQueryParameter['includeRevision'] = includeRevision;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccesspointsApi - functional programming interface
 */
export const AccesspointsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccesspointsApiAxiosParamCreator(configuration);
    return {
        /**
         * Asynchronously export access points matching the given search query to CSV. Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. The filter shape mirrors the scalar parameters of /registry/search, so the same registry-list filter values can be passed through. Empty body / null fields means \"all access points visible to the user\".
         * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBatchExport(accessPointBatchExportParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointBatchExport(accessPointBatchExportParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointBatchExport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Change state of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointChangeState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Change state of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointChangeStateRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Copying an archive entity
         * @param {string} id id of accesspoint
         * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCopyAccessPoint(id, copyAccessPointDetail, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointCopyAccessPoint(id, copyAccessPointDetail, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointCopyAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create new part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {object} body data for creating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreatePart(id, body, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointCreatePart(id, body, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointCreatePart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating a new revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreateRevision(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointCreateRevision(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointCreateRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Invalidation of access point (delete/replace)
         * @param {string} id id of accesspoint
         * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Invalidation of access points
         * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoints(deleteAccessPointsDetail, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteAccessPoints(deleteAccessPointsDetail, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteAccessPoints']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeletePart(id, partId, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeletePart(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeletePart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deleting a revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevision(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteRevision(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete part of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevisionPart(id, partId, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteRevisionPart(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteRevisionPart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Decision on forced export ELZA -> CAM
         * @param {number} queueItemId id of queue
         * @param {boolean} force force export: yes or no
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointExportForceOrNo(queueItemId, force, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointExportForceOrNo(queueItemId, force, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointExportForceOrNo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List of automatically generated elements of the description
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetAutoitems(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetAutoitems(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetAutoitems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get invalidated (deleted) entities
         * @param {number} [page] number of the page
         * @param {number} [pageSize] page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetInvalidatedEntities(page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetInvalidatedEntities(page, pageSize, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetInvalidatedEntities']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a list of entity processors
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetLastParticipants(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetLastParticipants(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetLastParticipants']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List of automatically generated description elements for revision
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetRevAutoitems(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetRevAutoitems(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetRevAutoitems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Merge ApRevision & ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointMergeRevision(id, apStateUpdate, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointMergeRevision(id, apStateUpdate, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointMergeRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Restore deleted entity and return to original state
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointRestoreAccessPoint(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointRestoreAccessPoint(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointRestoreAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
         * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSearch(accessPointSearchParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointSearch(accessPointSearchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set the preferred name of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferName(id, partId, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointSetPreferName(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointSetPreferName']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set the preferred name of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferNameRevision(id, partId, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointSetPreferNameRevision(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointSetPreferNameRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId id of part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdatePart(id, partId, body, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointUpdatePart(id, partId, body, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointUpdatePart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a revision part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} revPartId id of revision part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointUpdateRevisionPart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Validation of an archive entity
         * @param {number} id id of accesspoint
         * @param {boolean} [includeRevision] include revision
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointValidateAccessPoint(id, includeRevision, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointValidateAccessPoint(id, includeRevision, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointValidateAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AccesspointsApi - factory interface
 */
export const AccesspointsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccesspointsApiFp(configuration);
    return {
        /**
         * Asynchronously export access points matching the given search query to CSV. Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. The filter shape mirrors the scalar parameters of /registry/search, so the same registry-list filter values can be passed through. Empty body / null fields means \"all access points visible to the user\".
         * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBatchExport(accessPointBatchExportParams, options) {
            return localVarFp.accessPointBatchExport(accessPointBatchExportParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Change state of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options) {
            return localVarFp.accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Change state of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options) {
            return localVarFp.accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Copying an archive entity
         * @param {string} id id of accesspoint
         * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCopyAccessPoint(id, copyAccessPointDetail, options) {
            return localVarFp.accessPointCopyAccessPoint(id, copyAccessPointDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {object} body data for creating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreatePart(id, body, apVersion, options) {
            return localVarFp.accessPointCreatePart(id, body, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Creating a new revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreateRevision(id, options) {
            return localVarFp.accessPointCreateRevision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidation of access point (delete/replace)
         * @param {string} id id of accesspoint
         * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options) {
            return localVarFp.accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidation of access points
         * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoints(deleteAccessPointsDetail, options) {
            return localVarFp.accessPointDeleteAccessPoints(deleteAccessPointsDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeletePart(id, partId, apVersion, options) {
            return localVarFp.accessPointDeletePart(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Deleting a revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevision(id, options) {
            return localVarFp.accessPointDeleteRevision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete part of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevisionPart(id, partId, apVersion, options) {
            return localVarFp.accessPointDeleteRevisionPart(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Decision on forced export ELZA -> CAM
         * @param {number} queueItemId id of queue
         * @param {boolean} force force export: yes or no
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointExportForceOrNo(queueItemId, force, options) {
            return localVarFp.accessPointExportForceOrNo(queueItemId, force, options).then((request) => request(axios, basePath));
        },
        /**
         * List of automatically generated elements of the description
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetAutoitems(id, options) {
            return localVarFp.accessPointGetAutoitems(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get invalidated (deleted) entities
         * @param {number} [page] number of the page
         * @param {number} [pageSize] page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetInvalidatedEntities(page, pageSize, options) {
            return localVarFp.accessPointGetInvalidatedEntities(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of entity processors
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetLastParticipants(id, options) {
            return localVarFp.accessPointGetLastParticipants(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List of automatically generated description elements for revision
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetRevAutoitems(id, options) {
            return localVarFp.accessPointGetRevAutoitems(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Merge ApRevision & ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointMergeRevision(id, apStateUpdate, apVersion, options) {
            return localVarFp.accessPointMergeRevision(id, apStateUpdate, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Restore deleted entity and return to original state
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointRestoreAccessPoint(id, options) {
            return localVarFp.accessPointRestoreAccessPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
         * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSearch(accessPointSearchParams, options) {
            return localVarFp.accessPointSearch(accessPointSearchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the preferred name of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferName(id, partId, apVersion, options) {
            return localVarFp.accessPointSetPreferName(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the preferred name of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferNameRevision(id, partId, apVersion, options) {
            return localVarFp.accessPointSetPreferNameRevision(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId id of part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdatePart(id, partId, body, apVersion, options) {
            return localVarFp.accessPointUpdatePart(id, partId, body, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a revision part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} revPartId id of revision part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options) {
            return localVarFp.accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Validation of an archive entity
         * @param {number} id id of accesspoint
         * @param {boolean} [includeRevision] include revision
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointValidateAccessPoint(id, includeRevision, options) {
            return localVarFp.accessPointValidateAccessPoint(id, includeRevision, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccesspointsApi - object-oriented interface
 */
export class AccesspointsApi extends BaseAPI {
    /**
     * Asynchronously export access points matching the given search query to CSV. Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. The filter shape mirrors the scalar parameters of /registry/search, so the same registry-list filter values can be passed through. Empty body / null fields means \"all access points visible to the user\".
     * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointBatchExport(accessPointBatchExportParams, options) {
        return AccesspointsApiFp(this.configuration).accessPointBatchExport(accessPointBatchExportParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change state of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {ApStateUpdate} apStateUpdate data for change ApState
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {number} [assignTo] userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options) {
        return AccesspointsApiFp(this.configuration).accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change state of revision of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {number} [assignTo] userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options) {
        return AccesspointsApiFp(this.configuration).accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Copying an archive entity
     * @param {string} id id of accesspoint
     * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointCopyAccessPoint(id, copyAccessPointDetail, options) {
        return AccesspointsApiFp(this.configuration).accessPointCopyAccessPoint(id, copyAccessPointDetail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {object} body data for creating a part
     * @param {number} [apVersion] accesspoint version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointCreatePart(id, body, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointCreatePart(id, body, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating a new revision of access point
     * @param {number} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointCreateRevision(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointCreateRevision(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invalidation of access point (delete/replace)
     * @param {string} id id of accesspoint
     * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invalidation of access points
     * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteAccessPoints(deleteAccessPointsDetail, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteAccessPoints(deleteAccessPointsDetail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of ApAccessPoint
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeletePart(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeletePart(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deleting a revision of access point
     * @param {number} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteRevision(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteRevision(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete part of revision of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of revision
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteRevisionPart(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteRevisionPart(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Decision on forced export ELZA -> CAM
     * @param {number} queueItemId id of queue
     * @param {boolean} force force export: yes or no
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointExportForceOrNo(queueItemId, force, options) {
        return AccesspointsApiFp(this.configuration).accessPointExportForceOrNo(queueItemId, force, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List of automatically generated elements of the description
     * @param {string} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetAutoitems(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetAutoitems(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get invalidated (deleted) entities
     * @param {number} [page] number of the page
     * @param {number} [pageSize] page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetInvalidatedEntities(page, pageSize, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetInvalidatedEntities(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of entity processors
     * @param {number} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetLastParticipants(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetLastParticipants(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List of automatically generated description elements for revision
     * @param {string} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetRevAutoitems(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetRevAutoitems(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Merge ApRevision & ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {ApStateUpdate} apStateUpdate data for change ApState
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointMergeRevision(id, apStateUpdate, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointMergeRevision(id, apStateUpdate, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Restore deleted entity and return to original state
     * @param {string} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointRestoreAccessPoint(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointRestoreAccessPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
     * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointSearch(accessPointSearchParams, options) {
        return AccesspointsApiFp(this.configuration).accessPointSearch(accessPointSearchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set the preferred name of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of ApAccessPoint
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointSetPreferName(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointSetPreferName(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set the preferred name of revision of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of revision
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointSetPreferNameRevision(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointSetPreferNameRevision(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId id of part
     * @param {object} body data for updating a part
     * @param {number} [apVersion] accesspoint version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointUpdatePart(id, partId, body, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointUpdatePart(id, partId, body, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a revision part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} revPartId id of revision part
     * @param {object} body data for updating a part
     * @param {number} [apVersion] accesspoint version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Validation of an archive entity
     * @param {number} id id of accesspoint
     * @param {boolean} [includeRevision] include revision
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointValidateAccessPoint(id, includeRevision, options) {
        return AccesspointsApiFp(this.configuration).accessPointValidateAccessPoint(id, includeRevision, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminApi - axios parameter creator
 */
export const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copy user permissions from another user  Method will append all permissions to given user
         * @param {number} userId ID of target user
         * @param {AdminCopyPermissionParams} adminCopyPermissionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCopyPermissions: (userId, adminCopyPermissionParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminCopyPermissions', 'userId', userId);
            // verify required parameter 'adminCopyPermissionParams' is not null or undefined
            assertParamExists('adminCopyPermissions', 'adminCopyPermissionParams', adminCopyPermissionParams);
            const localVarPath = `/admin/user/{userId}/copy-permissions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminCopyPermissionParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return basic statistical info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of logged users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoggedUsers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/info/logged-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating missing items in arr_cached_node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncNodeCache: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/arrangement/missing-cached-nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminApi - functional programming interface
 */
export const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration);
    return {
        /**
         * Copy user permissions from another user  Method will append all permissions to given user
         * @param {number} userId ID of target user
         * @param {AdminCopyPermissionParams} adminCopyPermissionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCopyPermissions(userId, adminCopyPermissionParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCopyPermissions(userId, adminCopyPermissionParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminCopyPermissions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return basic statistical info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminInfo(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of logged users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoggedUsers(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLoggedUsers(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminLoggedUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating missing items in arr_cached_node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncNodeCache(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSyncNodeCache(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminSyncNodeCache']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AdminApi - factory interface
 */
export const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminApiFp(configuration);
    return {
        /**
         * Copy user permissions from another user  Method will append all permissions to given user
         * @param {number} userId ID of target user
         * @param {AdminCopyPermissionParams} adminCopyPermissionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCopyPermissions(userId, adminCopyPermissionParams, options) {
            return localVarFp.adminCopyPermissions(userId, adminCopyPermissionParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Return basic statistical info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo(options) {
            return localVarFp.adminInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of logged users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoggedUsers(options) {
            return localVarFp.adminLoggedUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Creating missing items in arr_cached_node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncNodeCache(options) {
            return localVarFp.adminSyncNodeCache(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminApi - object-oriented interface
 */
export class AdminApi extends BaseAPI {
    /**
     * Copy user permissions from another user  Method will append all permissions to given user
     * @param {number} userId ID of target user
     * @param {AdminCopyPermissionParams} adminCopyPermissionParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminCopyPermissions(userId, adminCopyPermissionParams, options) {
        return AdminApiFp(this.configuration).adminCopyPermissions(userId, adminCopyPermissionParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return basic statistical info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminInfo(options) {
        return AdminApiFp(this.configuration).adminInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of logged users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminLoggedUsers(options) {
        return AdminApiFp(this.configuration).adminLoggedUsers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating missing items in arr_cached_node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminSyncNodeCache(options) {
        return AdminApiFp(this.configuration).adminSyncNodeCache(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DaosApi - axios parameter creator
 */
export const DaosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Changing the dao connection scenario
         * @param {number} id dao id
         * @param {string} body new scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoChangeLinkScenario: (id, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('daoChangeLinkScenario', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('daoChangeLinkScenario', 'body', body);
            const localVarPath = `/daos/{id}/change-scenario`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DaosApi - functional programming interface
 */
export const DaosApiFp = function (configuration) {
    const localVarAxiosParamCreator = DaosApiAxiosParamCreator(configuration);
    return {
        /**
         * Changing the dao connection scenario
         * @param {number} id dao id
         * @param {string} body new scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoChangeLinkScenario(id, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.daoChangeLinkScenario(id, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DaosApi.daoChangeLinkScenario']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DaosApi - factory interface
 */
export const DaosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DaosApiFp(configuration);
    return {
        /**
         * Changing the dao connection scenario
         * @param {number} id dao id
         * @param {string} body new scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoChangeLinkScenario(id, body, options) {
            return localVarFp.daoChangeLinkScenario(id, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DaosApi - object-oriented interface
 */
export class DaosApi extends BaseAPI {
    /**
     * Changing the dao connection scenario
     * @param {number} id dao id
     * @param {string} body new scenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    daoChangeLinkScenario(id, body, options) {
        return DaosApiFp(this.configuration).daoChangeLinkScenario(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoRepositoryFsRepos: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/daorepository`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoRepositoryFsRepos(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.daoRepositoryFsRepos(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.daoRepositoryFsRepos']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoRepositoryFsRepos(options) {
            return localVarFp.daoRepositoryFsRepos(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    daoRepositoryFsRepos(options) {
        return DefaultApiFp(this.configuration).daoRepositoryFsRepos(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DescitemsApi - axios parameter creator
 */
export const DescitemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemCreateDescItem: (fundVersionId, nodeItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('descItemCreateDescItem', 'fundVersionId', fundVersionId);
            // verify required parameter 'nodeItem' is not null or undefined
            assertParamExists('descItemCreateDescItem', 'nodeItem', nodeItem);
            const localVarPath = `/descItems/{fundVersionId}/create`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemDeleteDescItem: (fundVersionId, nodeItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('descItemDeleteDescItem', 'fundVersionId', fundVersionId);
            // verify required parameter 'nodeItem' is not null or undefined
            assertParamExists('descItemDeleteDescItem', 'nodeItem', nodeItem);
            const localVarPath = `/descItems/{fundVersionId}`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update attribute value
         * @param {number} fundVersionId id version AS
         * @param {boolean} createNewVersion create a new version or not?
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemUpdateDescItem: (fundVersionId, createNewVersion, nodeItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('descItemUpdateDescItem', 'fundVersionId', fundVersionId);
            // verify required parameter 'createNewVersion' is not null or undefined
            assertParamExists('descItemUpdateDescItem', 'createNewVersion', createNewVersion);
            // verify required parameter 'nodeItem' is not null or undefined
            assertParamExists('descItemUpdateDescItem', 'nodeItem', nodeItem);
            const localVarPath = `/descItems/{fundVersionId}/{createNewVersion}/update`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)))
                .replace(`{${"createNewVersion"}}`, encodeURIComponent(String(createNewVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DescitemsApi - functional programming interface
 */
export const DescitemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DescitemsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemCreateDescItem(fundVersionId, nodeItem, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.descItemCreateDescItem(fundVersionId, nodeItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DescitemsApi.descItemCreateDescItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemDeleteDescItem(fundVersionId, nodeItem, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.descItemDeleteDescItem(fundVersionId, nodeItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DescitemsApi.descItemDeleteDescItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update attribute value
         * @param {number} fundVersionId id version AS
         * @param {boolean} createNewVersion create a new version or not?
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DescitemsApi.descItemUpdateDescItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DescitemsApi - factory interface
 */
export const DescitemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DescitemsApiFp(configuration);
    return {
        /**
         * Create attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemCreateDescItem(fundVersionId, nodeItem, options) {
            return localVarFp.descItemCreateDescItem(fundVersionId, nodeItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemDeleteDescItem(fundVersionId, nodeItem, options) {
            return localVarFp.descItemDeleteDescItem(fundVersionId, nodeItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Update attribute value
         * @param {number} fundVersionId id version AS
         * @param {boolean} createNewVersion create a new version or not?
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options) {
            return localVarFp.descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DescitemsApi - object-oriented interface
 */
export class DescitemsApi extends BaseAPI {
    /**
     * Create attribute value
     * @param {number} fundVersionId id version AS
     * @param {NodeItem} nodeItem new attribute value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    descItemCreateDescItem(fundVersionId, nodeItem, options) {
        return DescitemsApiFp(this.configuration).descItemCreateDescItem(fundVersionId, nodeItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete attribute value
     * @param {number} fundVersionId id version AS
     * @param {NodeItem} nodeItem attribute value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    descItemDeleteDescItem(fundVersionId, nodeItem, options) {
        return DescitemsApiFp(this.configuration).descItemDeleteDescItem(fundVersionId, nodeItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update attribute value
     * @param {number} fundVersionId id version AS
     * @param {boolean} createNewVersion create a new version or not?
     * @param {NodeItem} nodeItem new attribute value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options) {
        return DescitemsApiFp(this.configuration).descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExternalsystemsApi - axios parameter creator
 */
export const ExternalsystemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Return list of all properties of external system
         * @param {number} [extSystemId] external system id
         * @param {number} [userId] user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemAllProperties: (extSystemId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/extsystem/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (extSystemId !== undefined) {
                localVarQueryParameter['extSystemId'] = extSystemId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete one property of external system
         * @param {Array<number>} requestBody external system property id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemDeleteProperties: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('externalSystemDeleteProperties', 'requestBody', requestBody);
            const localVarPath = `/extsystem/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * External system resync
         * @param {string} id external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemExternalSystemResync: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('externalSystemExternalSystemResync', 'id', id);
            const localVarPath = `/extsystem/resync/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Store one or more property of external system
         * @param {Array<ExtSystemProperty>} extSystemProperty request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemStoreProperties: (extSystemProperty, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'extSystemProperty' is not null or undefined
            assertParamExists('externalSystemStoreProperties', 'extSystemProperty', extSystemProperty);
            const localVarPath = `/extsystem/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(extSystemProperty, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ExternalsystemsApi - functional programming interface
 */
export const ExternalsystemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExternalsystemsApiAxiosParamCreator(configuration);
    return {
        /**
         * Return list of all properties of external system
         * @param {number} [extSystemId] external system id
         * @param {number} [userId] user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemAllProperties(extSystemId, userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemAllProperties(extSystemId, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemAllProperties']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete one property of external system
         * @param {Array<number>} requestBody external system property id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemDeleteProperties(requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemDeleteProperties(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemDeleteProperties']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * External system resync
         * @param {string} id external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemExternalSystemResync(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemExternalSystemResync(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemExternalSystemResync']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Store one or more property of external system
         * @param {Array<ExtSystemProperty>} extSystemProperty request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemStoreProperties(extSystemProperty, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemStoreProperties(extSystemProperty, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemStoreProperties']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ExternalsystemsApi - factory interface
 */
export const ExternalsystemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExternalsystemsApiFp(configuration);
    return {
        /**
         * Return list of all properties of external system
         * @param {number} [extSystemId] external system id
         * @param {number} [userId] user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemAllProperties(extSystemId, userId, options) {
            return localVarFp.externalSystemAllProperties(extSystemId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one property of external system
         * @param {Array<number>} requestBody external system property id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemDeleteProperties(requestBody, options) {
            return localVarFp.externalSystemDeleteProperties(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * External system resync
         * @param {string} id external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemExternalSystemResync(id, options) {
            return localVarFp.externalSystemExternalSystemResync(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Store one or more property of external system
         * @param {Array<ExtSystemProperty>} extSystemProperty request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemStoreProperties(extSystemProperty, options) {
            return localVarFp.externalSystemStoreProperties(extSystemProperty, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExternalsystemsApi - object-oriented interface
 */
export class ExternalsystemsApi extends BaseAPI {
    /**
     * Return list of all properties of external system
     * @param {number} [extSystemId] external system id
     * @param {number} [userId] user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemAllProperties(extSystemId, userId, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemAllProperties(extSystemId, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete one property of external system
     * @param {Array<number>} requestBody external system property id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemDeleteProperties(requestBody, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemDeleteProperties(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * External system resync
     * @param {string} id external system ID or CODE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemExternalSystemResync(id, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemExternalSystemResync(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Store one or more property of external system
     * @param {Array<ExtSystemProperty>} extSystemProperty request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemStoreProperties(extSystemProperty, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemStoreProperties(extSystemProperty, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FundsApi - axios parameter creator
 */
export const FundsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Created a new archive file (AS)
         * @param {CreateFund} createFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundCreateFund: (createFund, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createFund' is not null or undefined
            assertParamExists('fundCreateFund', 'createFund', createFund);
            const localVarPath = `/fund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createFund, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Smazání seznamu hodnot strukturovaného datového typu
         * @param {number} id Identifikátor AS
         * @param {Array<number>} requestBody Seznam id hodnot strukturovaného datového typu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundDeleteStructureData: (id, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fundDeleteStructureData', 'id', id);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('fundDeleteStructureData', 'requestBody', requestBody);
            const localVarPath = `/fund/{id}/structuredObject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Export fonds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundExportFunds: (searchParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('fundExportFunds', 'searchParams', searchParams);
            const localVarPath = `/fund/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for archive files (AS)
         * @param {string} [fulltext] vyhledávaný výraz
         * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
         * @param {number} [max] maximální počet výsledků na stránku
         * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fundFindFunds: (fulltext, institutionIdentifier, max, from, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/fund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fulltext !== undefined) {
                localVarQueryParameter['fulltext'] = fulltext;
            }
            if (institutionIdentifier !== undefined) {
                localVarQueryParameter['institutionIdentifier'] = institutionIdentifier;
            }
            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create DAO link
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {number} nodeId Node ID
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsCreateDAOLink: (fundId, fsrepoId, nodeId, path, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsCreateDAOLink', 'fundId', fundId);
            // verify required parameter 'fsrepoId' is not null or undefined
            assertParamExists('fundFsCreateDAOLink', 'fsrepoId', fsrepoId);
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('fundFsCreateDAOLink', 'nodeId', nodeId);
            const localVarPath = `/fund/{fundId}/fsrepo/{fsrepoId}/linkitem/{nodeId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fsrepoId"}}`, encodeURIComponent(String(fsrepoId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get file of data
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {string} path file path in the repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItemData: (fundId, fsrepoId, path, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsRepoItemData', 'fundId', fundId);
            // verify required parameter 'fsrepoId' is not null or undefined
            assertParamExists('fundFsRepoItemData', 'fsrepoId', fsrepoId);
            // verify required parameter 'path' is not null or undefined
            assertParamExists('fundFsRepoItemData', 'path', path);
            const localVarPath = `/fund/{fundId}/fsrepo/{fsrepoId}/item-data`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fsrepoId"}}`, encodeURIComponent(String(fsrepoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of filesystem items
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
         * @param {string} [path] Optional path in the repository
         * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItems: (fundId, fsrepoId, filterType, path, lastKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsRepoItems', 'fundId', fundId);
            // verify required parameter 'fsrepoId' is not null or undefined
            assertParamExists('fundFsRepoItems', 'fsrepoId', fsrepoId);
            const localVarPath = `/fund/{fundId}/fsrepo/{fsrepoId}/items`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fsrepoId"}}`, encodeURIComponent(String(fsrepoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filterType !== undefined) {
                localVarQueryParameter['filterType'] = filterType;
            }
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of filesystem repositories
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepos: (fundId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsRepos', 'fundId', fundId);
            const localVarPath = `/fund/{fundId}/fsrepos`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the AS detail
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundGetFund: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fundGetFund', 'id', id);
            const localVarPath = `/fund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Import additional data to the existing fund
         * @param {string} id Fund ID. Might be ID or fund UUID
         * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
         * @param {File} dataFile File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundImportFundData: (id, importType, dataFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fundImportFundData', 'id', id);
            // verify required parameter 'importType' is not null or undefined
            assertParamExists('fundImportFundData', 'importType', importType);
            // verify required parameter 'dataFile' is not null or undefined
            assertParamExists('fundImportFundData', 'dataFile', dataFile);
            const localVarPath = `/fund/{id}/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (importType !== undefined) {
                localVarFormParams.append('importType', importType);
            }
            if (dataFile !== undefined) {
                localVarFormParams.append('dataFile', dataFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for funds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSearchFunds: (searchParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('fundSearchFunds', 'searchParams', searchParams);
            const localVarPath = `/fund/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set mode (TREE/LIST) of ArrLevel
         * @param {number} fundId Fund ID
         * @param {number} nodeId Node ID
         * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSetLevelMode: (fundId, nodeId, list, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundSetLevelMode', 'fundId', fundId);
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('fundSetLevelMode', 'nodeId', nodeId);
            // verify required parameter 'list' is not null or undefined
            assertParamExists('fundSetLevelMode', 'list', list);
            const localVarPath = `/fund/{fundId}/node/{nodeId}/mode`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (list !== undefined) {
                localVarQueryParameter['list'] = list;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update of archive file (AS)
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {UpdateFund} updateFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUpdateFund: (id, updateFund, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fundUpdateFund', 'id', id);
            // verify required parameter 'updateFund' is not null or undefined
            assertParamExists('fundUpdateFund', 'updateFund', updateFund);
            const localVarPath = `/fund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateFund, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of item type id & count
         * @param {number} fundId Fund ID
         * @param {number} fundVersionId Fund ID Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUsedItemTypes: (fundId, fundVersionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundUsedItemTypes', 'fundId', fundId);
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('fundUsedItemTypes', 'fundVersionId', fundVersionId);
            const localVarPath = `/fund/{fundId}/usedItemtypes/{fundVersionId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FundsApi - functional programming interface
 */
export const FundsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FundsApiAxiosParamCreator(configuration);
    return {
        /**
         * Created a new archive file (AS)
         * @param {CreateFund} createFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundCreateFund(createFund, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundCreateFund(createFund, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundCreateFund']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Smazání seznamu hodnot strukturovaného datového typu
         * @param {number} id Identifikátor AS
         * @param {Array<number>} requestBody Seznam id hodnot strukturovaného datového typu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundDeleteStructureData(id, requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundDeleteStructureData(id, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundDeleteStructureData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Export fonds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundExportFunds(searchParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundExportFunds(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundExportFunds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for archive files (AS)
         * @param {string} [fulltext] vyhledávaný výraz
         * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
         * @param {number} [max] maximální počet výsledků na stránku
         * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fundFindFunds(fulltext, institutionIdentifier, max, from, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFindFunds(fulltext, institutionIdentifier, max, from, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFindFunds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create DAO link
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {number} nodeId Node ID
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsCreateDAOLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get file of data
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {string} path file path in the repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItemData(fundId, fsrepoId, path, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsRepoItemData(fundId, fsrepoId, path, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsRepoItemData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of filesystem items
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
         * @param {string} [path] Optional path in the repository
         * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsRepoItems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of filesystem repositories
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepos(fundId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsRepos(fundId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsRepos']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the AS detail
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundGetFund(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundGetFund(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundGetFund']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Import additional data to the existing fund
         * @param {string} id Fund ID. Might be ID or fund UUID
         * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
         * @param {File} dataFile File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundImportFundData(id, importType, dataFile, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundImportFundData(id, importType, dataFile, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundImportFundData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for funds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSearchFunds(searchParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundSearchFunds(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundSearchFunds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set mode (TREE/LIST) of ArrLevel
         * @param {number} fundId Fund ID
         * @param {number} nodeId Node ID
         * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSetLevelMode(fundId, nodeId, list, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundSetLevelMode(fundId, nodeId, list, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundSetLevelMode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update of archive file (AS)
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {UpdateFund} updateFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUpdateFund(id, updateFund, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundUpdateFund(id, updateFund, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundUpdateFund']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of item type id & count
         * @param {number} fundId Fund ID
         * @param {number} fundVersionId Fund ID Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUsedItemTypes(fundId, fundVersionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundUsedItemTypes(fundId, fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundUsedItemTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * FundsApi - factory interface
 */
export const FundsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FundsApiFp(configuration);
    return {
        /**
         * Created a new archive file (AS)
         * @param {CreateFund} createFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundCreateFund(createFund, options) {
            return localVarFp.fundCreateFund(createFund, options).then((request) => request(axios, basePath));
        },
        /**
         * Smazání seznamu hodnot strukturovaného datového typu
         * @param {number} id Identifikátor AS
         * @param {Array<number>} requestBody Seznam id hodnot strukturovaného datového typu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundDeleteStructureData(id, requestBody, options) {
            return localVarFp.fundDeleteStructureData(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Export fonds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundExportFunds(searchParams, options) {
            return localVarFp.fundExportFunds(searchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for archive files (AS)
         * @param {string} [fulltext] vyhledávaný výraz
         * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
         * @param {number} [max] maximální počet výsledků na stránku
         * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fundFindFunds(fulltext, institutionIdentifier, max, from, options) {
            return localVarFp.fundFindFunds(fulltext, institutionIdentifier, max, from, options).then((request) => request(axios, basePath));
        },
        /**
         * Create DAO link
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {number} nodeId Node ID
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options) {
            return localVarFp.fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * Get file of data
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {string} path file path in the repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItemData(fundId, fsrepoId, path, options) {
            return localVarFp.fundFsRepoItemData(fundId, fsrepoId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of filesystem items
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
         * @param {string} [path] Optional path in the repository
         * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, options) {
            return localVarFp.fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of filesystem repositories
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepos(fundId, options) {
            return localVarFp.fundFsRepos(fundId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the AS detail
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundGetFund(id, options) {
            return localVarFp.fundGetFund(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Import additional data to the existing fund
         * @param {string} id Fund ID. Might be ID or fund UUID
         * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
         * @param {File} dataFile File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundImportFundData(id, importType, dataFile, options) {
            return localVarFp.fundImportFundData(id, importType, dataFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for funds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSearchFunds(searchParams, options) {
            return localVarFp.fundSearchFunds(searchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Set mode (TREE/LIST) of ArrLevel
         * @param {number} fundId Fund ID
         * @param {number} nodeId Node ID
         * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSetLevelMode(fundId, nodeId, list, options) {
            return localVarFp.fundSetLevelMode(fundId, nodeId, list, options).then((request) => request(axios, basePath));
        },
        /**
         * Update of archive file (AS)
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {UpdateFund} updateFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUpdateFund(id, updateFund, options) {
            return localVarFp.fundUpdateFund(id, updateFund, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of item type id & count
         * @param {number} fundId Fund ID
         * @param {number} fundVersionId Fund ID Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUsedItemTypes(fundId, fundVersionId, options) {
            return localVarFp.fundUsedItemTypes(fundId, fundVersionId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FundsApi - object-oriented interface
 */
export class FundsApi extends BaseAPI {
    /**
     * Created a new archive file (AS)
     * @param {CreateFund} createFund
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCreateFund(createFund, options) {
        return FundsApiFp(this.configuration).fundCreateFund(createFund, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Smazání seznamu hodnot strukturovaného datového typu
     * @param {number} id Identifikátor AS
     * @param {Array<number>} requestBody Seznam id hodnot strukturovaného datového typu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundDeleteStructureData(id, requestBody, options) {
        return FundsApiFp(this.configuration).fundDeleteStructureData(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Export fonds
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundExportFunds(searchParams, options) {
        return FundsApiFp(this.configuration).fundExportFunds(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for archive files (AS)
     * @param {string} [fulltext] vyhledávaný výraz
     * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
     * @param {number} [max] maximální počet výsledků na stránku
     * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    fundFindFunds(fulltext, institutionIdentifier, max, from, options) {
        return FundsApiFp(this.configuration).fundFindFunds(fulltext, institutionIdentifier, max, from, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create DAO link
     * @param {number} fundId Fund ID
     * @param {number} fsrepoId FileSystem repository ID
     * @param {number} nodeId Node ID
     * @param {string} [path]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options) {
        return FundsApiFp(this.configuration).fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get file of data
     * @param {number} fundId Fund ID
     * @param {number} fsrepoId FileSystem repository ID
     * @param {string} path file path in the repository
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsRepoItemData(fundId, fsrepoId, path, options) {
        return FundsApiFp(this.configuration).fundFsRepoItemData(fundId, fsrepoId, path, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of filesystem items
     * @param {number} fundId Fund ID
     * @param {number} fsrepoId FileSystem repository ID
     * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
     * @param {string} [path] Optional path in the repository
     * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, options) {
        return FundsApiFp(this.configuration).fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of filesystem repositories
     * @param {number} fundId Fund ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsRepos(fundId, options) {
        return FundsApiFp(this.configuration).fundFsRepos(fundId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the AS detail
     * @param {string} id fund ID. Might be ID or fund UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundGetFund(id, options) {
        return FundsApiFp(this.configuration).fundGetFund(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Import additional data to the existing fund
     * @param {string} id Fund ID. Might be ID or fund UUID
     * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
     * @param {File} dataFile File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundImportFundData(id, importType, dataFile, options) {
        return FundsApiFp(this.configuration).fundImportFundData(id, importType, dataFile, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for funds
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundSearchFunds(searchParams, options) {
        return FundsApiFp(this.configuration).fundSearchFunds(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set mode (TREE/LIST) of ArrLevel
     * @param {number} fundId Fund ID
     * @param {number} nodeId Node ID
     * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundSetLevelMode(fundId, nodeId, list, options) {
        return FundsApiFp(this.configuration).fundSetLevelMode(fundId, nodeId, list, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update of archive file (AS)
     * @param {string} id fund ID. Might be ID or fund UUID
     * @param {UpdateFund} updateFund
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundUpdateFund(id, updateFund, options) {
        return FundsApiFp(this.configuration).fundUpdateFund(id, updateFund, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of item type id & count
     * @param {number} fundId Fund ID
     * @param {number} fundVersionId Fund ID Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundUsedItemTypes(fundId, fundVersionId, options) {
        return FundsApiFp(this.configuration).fundUsedItemTypes(fundId, fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IoApi - axios parameter creator
 */
export const IoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create export file of funds or access points
         * @param {ExportParams} exportParams Export request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioExportRequest: (exportParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'exportParams' is not null or undefined
            assertParamExists('ioExportRequest', 'exportParams', exportParams);
            const localVarPath = `/io/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(exportParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the generated file by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportFile: (requestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('ioGetExportFile', 'requestId', requestId);
            const localVarPath = `/io/file/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the export status by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportStatus: (requestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('ioGetExportStatus', 'requestId', requestId);
            const localVarPath = `/io/export-status/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * IoApi - functional programming interface
 */
export const IoApiFp = function (configuration) {
    const localVarAxiosParamCreator = IoApiAxiosParamCreator(configuration);
    return {
        /**
         * Create export file of funds or access points
         * @param {ExportParams} exportParams Export request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioExportRequest(exportParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ioExportRequest(exportParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IoApi.ioExportRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the generated file by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportFile(requestId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ioGetExportFile(requestId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IoApi.ioGetExportFile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the export status by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportStatus(requestId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ioGetExportStatus(requestId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IoApi.ioGetExportStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * IoApi - factory interface
 */
export const IoApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IoApiFp(configuration);
    return {
        /**
         * Create export file of funds or access points
         * @param {ExportParams} exportParams Export request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioExportRequest(exportParams, options) {
            return localVarFp.ioExportRequest(exportParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the generated file by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportFile(requestId, options) {
            return localVarFp.ioGetExportFile(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the export status by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportStatus(requestId, options) {
            return localVarFp.ioGetExportStatus(requestId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * IoApi - object-oriented interface
 */
export class IoApi extends BaseAPI {
    /**
     * Create export file of funds or access points
     * @param {ExportParams} exportParams Export request parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ioExportRequest(exportParams, options) {
        return IoApiFp(this.configuration).ioExportRequest(exportParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the generated file by request id
     * @param {number} requestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ioGetExportFile(requestId, options) {
        return IoApiFp(this.configuration).ioGetExportFile(requestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the export status by request id
     * @param {number} requestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ioGetExportStatus(requestId, options) {
        return IoApiFp(this.configuration).ioGetExportStatus(requestId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NodeApi - axios parameter creator
 */
export const NodeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copies the attribute of the specified type from the node\'s parent
         * @param {number} versionId version id of tree
         * @param {number} descItemTypeId id of the attribute we want to copy
         * @param {NodeBase} nodeBase node to assign values from the older brother
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeCopyOlderSiblingAttribute: (versionId, descItemTypeId, nodeBase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('nodeCopyOlderSiblingAttribute', 'versionId', versionId);
            // verify required parameter 'descItemTypeId' is not null or undefined
            assertParamExists('nodeCopyOlderSiblingAttribute', 'descItemTypeId', descItemTypeId);
            // verify required parameter 'nodeBase' is not null or undefined
            assertParamExists('nodeCopyOlderSiblingAttribute', 'nodeBase', nodeBase);
            const localVarPath = `/node/copyOlderSiblingAttribute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (versionId !== undefined) {
                localVarQueryParameter['versionId'] = versionId;
            }
            if (descItemTypeId !== undefined) {
                localVarQueryParameter['descItemTypeId'] = descItemTypeId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeBase, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get data for a unit of description (JP)
         * @param {NodeDataParam} nodeDataParam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeData: (nodeDataParam, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'nodeDataParam' is not null or undefined
            assertParamExists('nodeGetNodeData', 'nodeDataParam', nodeDataParam);
            const localVarPath = `/node/node-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeDataParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get quote by fundVersionId & nodeId
         * @param {number} fundVersionId
         * @param {number} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetPlainText: (fundVersionId, nodeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('nodeGetPlainText', 'fundVersionId', fundVersionId);
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('nodeGetPlainText', 'nodeId', nodeId);
            const localVarPath = `/node/plain-text/{fundVersionId}/{nodeId}`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for nodes in archive file (fund)
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetSearchResult: (fundId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('nodeGetSearchResult', 'fundId', fundId);
            const localVarPath = `/node/search/{fundId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for archive files (funds)
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeSearch: (searchParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('nodeSearch', 'searchParams', searchParams);
            const localVarPath = `/node/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NodeApi - functional programming interface
 */
export const NodeApiFp = function (configuration) {
    const localVarAxiosParamCreator = NodeApiAxiosParamCreator(configuration);
    return {
        /**
         * Copies the attribute of the specified type from the node\'s parent
         * @param {number} versionId version id of tree
         * @param {number} descItemTypeId id of the attribute we want to copy
         * @param {NodeBase} nodeBase node to assign values from the older brother
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeCopyOlderSiblingAttribute']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get data for a unit of description (JP)
         * @param {NodeDataParam} nodeDataParam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeData(nodeDataParam, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetNodeData(nodeDataParam, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetNodeData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get quote by fundVersionId & nodeId
         * @param {number} fundVersionId
         * @param {number} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetPlainText(fundVersionId, nodeId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetPlainText(fundVersionId, nodeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetPlainText']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for nodes in archive file (fund)
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetSearchResult(fundId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetSearchResult(fundId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetSearchResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for archive files (funds)
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeSearch(searchParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeSearch(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * NodeApi - factory interface
 */
export const NodeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NodeApiFp(configuration);
    return {
        /**
         * Copies the attribute of the specified type from the node\'s parent
         * @param {number} versionId version id of tree
         * @param {number} descItemTypeId id of the attribute we want to copy
         * @param {NodeBase} nodeBase node to assign values from the older brother
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options) {
            return localVarFp.nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get data for a unit of description (JP)
         * @param {NodeDataParam} nodeDataParam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeData(nodeDataParam, options) {
            return localVarFp.nodeGetNodeData(nodeDataParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Get quote by fundVersionId & nodeId
         * @param {number} fundVersionId
         * @param {number} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetPlainText(fundVersionId, nodeId, options) {
            return localVarFp.nodeGetPlainText(fundVersionId, nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for nodes in archive file (fund)
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetSearchResult(fundId, options) {
            return localVarFp.nodeGetSearchResult(fundId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for archive files (funds)
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeSearch(searchParams, options) {
            return localVarFp.nodeSearch(searchParams, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NodeApi - object-oriented interface
 */
export class NodeApi extends BaseAPI {
    /**
     * Copies the attribute of the specified type from the node\'s parent
     * @param {number} versionId version id of tree
     * @param {number} descItemTypeId id of the attribute we want to copy
     * @param {NodeBase} nodeBase node to assign values from the older brother
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options) {
        return NodeApiFp(this.configuration).nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get data for a unit of description (JP)
     * @param {NodeDataParam} nodeDataParam
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetNodeData(nodeDataParam, options) {
        return NodeApiFp(this.configuration).nodeGetNodeData(nodeDataParam, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get quote by fundVersionId & nodeId
     * @param {number} fundVersionId
     * @param {number} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetPlainText(fundVersionId, nodeId, options) {
        return NodeApiFp(this.configuration).nodeGetPlainText(fundVersionId, nodeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for nodes in archive file (fund)
     * @param {number} fundId Fund ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetSearchResult(fundId, options) {
        return NodeApiFp(this.configuration).nodeGetSearchResult(fundId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for archive files (funds)
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeSearch(searchParams, options) {
        return NodeApiFp(this.configuration).nodeSearch(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReportApi - axios parameter creator
 */
export const ReportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Run generating statistics
         * @param {string} code statistický kód pro generování
         * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGenerateReport: (code, reportReportParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('reportGenerateReport', 'code', code);
            // verify required parameter 'reportReportParameters' is not null or undefined
            assertParamExists('reportGenerateReport', 'reportReportParameters', reportReportParameters);
            const localVarPath = `/report/generate/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportReportParameters, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting a list of categories  and report definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetDefinitions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/report/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download statistics results by request id
         * @param {number} requestId
         * @param {ReportReportFormat} format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReport: (requestId, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('reportGetReport', 'requestId', requestId);
            // verify required parameter 'format' is not null or undefined
            assertParamExists('reportGetReport', 'format', format);
            const localVarPath = `/report/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the status of running statistics
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReportStatus: (requestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('reportGetReportStatus', 'requestId', requestId);
            const localVarPath = `/report/status/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReportApi - functional programming interface
 */
export const ReportApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration);
    return {
        /**
         * Run generating statistics
         * @param {string} code statistický kód pro generování
         * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGenerateReport(code, reportReportParameters, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGenerateReport(code, reportReportParameters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGenerateReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting a list of categories  and report definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetDefinitions(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGetDefinitions(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGetDefinitions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Download statistics results by request id
         * @param {number} requestId
         * @param {ReportReportFormat} format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReport(requestId, format, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGetReport(requestId, format, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGetReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get the status of running statistics
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReportStatus(requestId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGetReportStatus(requestId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGetReportStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ReportApi - factory interface
 */
export const ReportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportApiFp(configuration);
    return {
        /**
         * Run generating statistics
         * @param {string} code statistický kód pro generování
         * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGenerateReport(code, reportReportParameters, options) {
            return localVarFp.reportGenerateReport(code, reportReportParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting a list of categories  and report definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetDefinitions(options) {
            return localVarFp.reportGetDefinitions(options).then((request) => request(axios, basePath));
        },
        /**
         * Download statistics results by request id
         * @param {number} requestId
         * @param {ReportReportFormat} format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReport(requestId, format, options) {
            return localVarFp.reportGetReport(requestId, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of running statistics
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReportStatus(requestId, options) {
            return localVarFp.reportGetReportStatus(requestId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportApi - object-oriented interface
 */
export class ReportApi extends BaseAPI {
    /**
     * Run generating statistics
     * @param {string} code statistický kód pro generování
     * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGenerateReport(code, reportReportParameters, options) {
        return ReportApiFp(this.configuration).reportGenerateReport(code, reportReportParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting a list of categories  and report definitions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGetDefinitions(options) {
        return ReportApiFp(this.configuration).reportGetDefinitions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Download statistics results by request id
     * @param {number} requestId
     * @param {ReportReportFormat} format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGetReport(requestId, format, options) {
        return ReportApiFp(this.configuration).reportGetReport(requestId, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the status of running statistics
     * @param {number} requestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGetReportStatus(requestId, options) {
        return ReportApiFp(this.configuration).reportGetReportStatus(requestId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SearchApi - axios parameter creator
 */
export const SearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Searches for array descriptions
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchDesc: (searchParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('searchArchDesc', 'searchParams', searchParams);
            const localVarPath = `/search-arr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for entity
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntity: (searchParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('searchEntity', 'searchParams', searchParams);
            const localVarPath = `/search-ap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SearchApi - functional programming interface
 */
export const SearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration);
    return {
        /**
         * Searches for array descriptions
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchDesc(searchParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchArchDesc(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SearchApi.searchArchDesc']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Searches for entity
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntity(searchParams, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchEntity(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SearchApi.searchEntity']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * SearchApi - factory interface
 */
export const SearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchApiFp(configuration);
    return {
        /**
         * Searches for array descriptions
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchDesc(searchParams, options) {
            return localVarFp.searchArchDesc(searchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for entity
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntity(searchParams, options) {
            return localVarFp.searchEntity(searchParams, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchApi - object-oriented interface
 */
export class SearchApi extends BaseAPI {
    /**
     * Searches for array descriptions
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchArchDesc(searchParams, options) {
        return SearchApiFp(this.configuration).searchArchDesc(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for entity
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchEntity(searchParams, options) {
        return SearchApiFp(this.configuration).searchEntity(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TasksApi - axios parameter creator
 */
export const TasksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Task list for a given user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGetMyTasks: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TasksApi - functional programming interface
 */
export const TasksApiFp = function (configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration);
    return {
        /**
         * Task list for a given user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGetMyTasks(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tasksGetMyTasks(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TasksApi.tasksGetMyTasks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * TasksApi - factory interface
 */
export const TasksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TasksApiFp(configuration);
    return {
        /**
         * Task list for a given user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGetMyTasks(options) {
            return localVarFp.tasksGetMyTasks(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TasksApi - object-oriented interface
 */
export class TasksApi extends BaseAPI {
    /**
     * Task list for a given user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksGetMyTasks(options) {
        return TasksApiFp(this.configuration).tasksGetMyTasks(options).then((request) => request(this.axios, this.basePath));
    }
}
